import React from 'react';
import "../pages/css/add-property.css";
import cloud from "../assets/cloud.png";

const ReusableUpload = ({images, setImages, setData, data, dataErr }) => {

      const handleFileChange = (event) => {
    const files = Array.from(event.target.files);

    if (files.length + images.length > 5) {
      alert("You can only upload up to 5 images.");
      return;
    }
    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      };
  
      const processFiles = async () => {
        const newImages = await Promise.all(
          files.map(async (file) => ({
            file,
            base64: await convertToBase64(file),
          }))
        );
        setImages((prevImages) => [...prevImages, ...newImages]);
        setData({...data, pictures: newImages.map((img) => img.base64)})
      };
  
      processFiles();
  };

  return (
    
        <div className="images prop-form_cont">
          <label htmlFor="picture" className="prop-form img-upload" style={{width: "100%"}}>
            <input
              type="file"
              name="picture"
              id="picture"
              style={{ display: "none" }}
              multiple
              accept=".png, .jpg, .gif, .svg"
              onChange={handleFileChange}
            />
            <img src={cloud} alt="upload" />
            <p>
              <span>Click to upload</span> <br />
              SVG, PNG, JPG or GIF (max. 800x400px) <br />
              Upload max. 5 in total
            </p>
            <div style={{ display: "flex", gap: "10px", marginTop: "10px", flexWrap: "wrap", justifyContent: "center" }}>
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img.base64}
                  alt="preview"
                  width="100"
                  height="100"
                  style={{ objectFit: "cover", borderRadius: "5px" }}
                />
              ))}
            </div>
          </label>
          {dataErr?.pictures && <p>{dataErr.pictures}</p>}
        </div>
  )
}

export default ReusableUpload